import { render } from "./NewsletterSectionsMarketActivityEditing.vue?vue&type=template&id=efa05270&ts=true"
import script from "./NewsletterSectionsMarketActivityEditing.vue?vue&type=script&lang=ts"
export * from "./NewsletterSectionsMarketActivityEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__